import React, { PropsWithChildren } from 'react'
import MuiAlert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'

type ErrorBoundaryStateProps = {
    hasError: boolean
}
export default class ErrorBoundary extends React.Component<PropsWithChildren, ErrorBoundaryStateProps> {
    constructor(props: PropsWithChildren) {
        super(props)
        this.state = {
            hasError: false,
        }
        this.handleClose = this.handleClose.bind(this)
    }

    static getDerivedStateFromError() {
        return {
            hasError: true,
        }
    }

    componentDidCatch(error: any, errorInfo: any) {
        console.log('[IDS][ERROR_BOUNDARY]', error, errorInfo)
    }

    handleClose() {
        this.setState({
            hasError: false,
        })
    }

    render() {
        const { state } = this
        const { children } = this.props
        if (state.hasError) {
            return (
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open
                >
                    <MuiAlert severity="error" elevation={6} variant="filled" onClose={this.handleClose}>
                        Une erreur est apparue.
                    </MuiAlert>
                </Snackbar>
            )
        }

        return children
    }
}
